import type { RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import { type JSX, memo, useMemo } from "react";

import styles from "@components/organisms/table/styles.module.scss";
import type { ICellComponentProps } from "@components/organisms/table/types";
import { getCellKey } from "@components/organisms/table/tbody/helper";

export const CellComponent = memo(function CellComponent<
  TData extends RowData,
>({ cellEl }: ICellComponentProps<TData>) {
  const isEmpty = useMemo(
    () =>
      cellEl?.column?.accessorFn
        ? !cellEl.getValue() &&
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          !(cellEl.column.columnDef as any)?.accessorKey
        : false,
    [cellEl],
  );

  const cellContent = useMemo(
    () => flexRender(cellEl.column.columnDef.cell, cellEl.getContext()),
    [cellEl],
  );

  return useMemo(
    () => (
      <td key={getCellKey(cellEl)} className={styles.td}>
        <div className={styles.cell}>{isEmpty ? "- - -" : cellContent}</div>
      </td>
    ),
    [cellContent, cellEl, isEmpty],
  );
}) as <TData extends RowData>(props: ICellComponentProps<TData>) => JSX.Element;
